import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { solicitacaoService } from '../services/solicitacaoService';
import Button from './ui/Button';

/** Atalho na área de trabalho do parlamentar: fazer um pedido e ver quantos aguardam resposta. */
const CartaoFaleComEquipe: React.FC = () => {
  const navigate = useNavigate();
  const minhas = useQuery({ queryKey: ['solicitacoes', 'minhas'], queryFn: solicitacaoService.minhas });
  const aguardando = (minhas.data ?? []).filter((s) => s.status === 'ABERTA' || s.status === 'EM_ANALISE').length;

  return (
    <section className="rounded-2xl border border-line bg-surface p-5 shadow-sm">
      <h2 className="text-xl font-bold text-fg">Fale com a equipe</h2>
      <p className="mt-1 text-base leading-7 text-fg-muted">
        Precisa mudar algo ou tem uma dúvida? Faça um pedido aqui, sem precisar mandar mensagem.
      </p>
      <div className="mt-4 flex flex-col gap-3 sm:flex-row">
        <Button variant="primary" className="min-h-[52px] px-6 text-base" onClick={() => navigate('/dashboard/solicitacoes')}>
          Fazer um pedido ou tirar uma dúvida
        </Button>
        <Button variant="secondary" className="min-h-[52px] px-6 text-base" onClick={() => navigate('/dashboard/solicitacoes')}>
          Meus pedidos{aguardando > 0 ? ` (${aguardando} aguardando)` : ''}
        </Button>
      </div>
    </section>
  );
};

export default CartaoFaleComEquipe;
